module.exports = __webpack_public_path__ + "static/media/pin-icon.ac9b0ff8.svg";